module.exports = __webpack_public_path__ + "img/envelope.3ad45181.svg";